export const DEFAULT_THEME_COLOR = "#179C43";

export const THEME_COLOR_OPTIONS = [
  { label: "Green", value: "#179C43" },
  { label: "Teal", value: "#6BA4A2" },
  { label: "Blue Grey", value: "#7183A5" },
  { label: "Olive Green", value: "#6D8764" },
  { label: "Warm Sand", value: "#B39770" },
  { label: "Rose Mauve", value: "#AF7890" },
  { label: "Soft Violet", value: "#8576B7" },
  { label: "Mint", value: "#72BA9B" },
] as const;
